import React from "react";
import { SITE } from "@/data/site";

// Logos officiels, SVG inline optimisés (aucun script ni widget externe).
const InstagramGlyph = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" aria-hidden="true" focusable="false">
    <rect x="3" y="3" width="18" height="18" rx="5" fill="none" stroke="#fff" strokeWidth="1.9" />
    <circle cx="12" cy="12" r="4.1" fill="none" stroke="#fff" strokeWidth="1.9" />
    <circle cx="17.3" cy="6.7" r="1.25" fill="#fff" />
  </svg>
);

const FacebookGlyph = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" aria-hidden="true" focusable="false">
    <path
      fill="#fff"
      d="M15.12 23v-8.4h2.83l.42-3.28h-3.25V9.23c0-.95.26-1.6 1.63-1.6h1.74V4.7c-.3-.04-1.33-.13-2.53-.13-2.5 0-4.22 1.53-4.22 4.34v2.41H8.9v3.28h2.84V23h3.38z"
    />
  </svg>
);

const LinkedInGlyph = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" aria-hidden="true" focusable="false">
    <path
      fill="#fff"
      d="M6.94 8.6v10.4H3.6V8.6h3.34zM5.27 3.6a1.93 1.93 0 1 1 0 3.87 1.93 1.93 0 0 1 0-3.87zM20.4 19h-3.33v-5.2c0-1.24-.03-2.84-1.73-2.84-1.73 0-2 1.35-2 2.75V19H10V8.6h3.2v1.42h.04c.45-.84 1.53-1.73 3.15-1.73 3.37 0 3.99 2.21 3.99 5.1V19z"
    />
  </svg>
);

const TikTokGlyph = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" aria-hidden="true" focusable="false">
    <path
      fill="#25F4EE"
      d="M8.9 9.75v1.96a4.8 4.8 0 0 0-.83-.07 4.4 4.4 0 1 0 4.4 4.4V2.6h1.98c0 .18.02.36.05.54H12.5v13.44a4.4 4.4 0 0 1-6.95 3.58 4.4 4.4 0 0 1 3.35-7.4c.01-.34.01-2.67 0-3.01z"
    />
    <path
      fill="#FE2C55"
      d="M18.06 7.3v1.93a7.5 7.5 0 0 1-4.02-1.28v7.86a5.66 5.66 0 0 1-9.6 4.05 5.66 5.66 0 0 0 9.14-4.47V7.55a7.5 7.5 0 0 0 4.02 1.28V7.32l.46-.02z"
    />
    <path
      fill="#fff"
      d="M14.04 2.6c.3 1.63 1.3 3 2.73 3.73a4.6 4.6 0 0 0 1.29.45v2.05a7.5 7.5 0 0 1-4.02-1.28v7.86A5.66 5.66 0 1 1 8.38 9.7c.18 0 .35.01.52.03v2.04a3.63 3.63 0 1 0 2.56 3.47V2.6h2.58z"
    />
  </svg>
);

const YouTubeGlyph = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" aria-hidden="true" focusable="false">
    <path
      fill="#fff"
      d="M22.1 7.6a2.65 2.65 0 0 0-1.86-1.87C18.6 5.28 12 5.28 12 5.28s-6.6 0-8.24.45A2.65 2.65 0 0 0 1.9 7.6 27.6 27.6 0 0 0 1.46 12c0 1.48.15 2.96.44 4.4a2.65 2.65 0 0 0 1.86 1.87c1.64.45 8.24.45 8.24.45s6.6 0 8.24-.45a2.65 2.65 0 0 0 1.86-1.87c.29-1.44.44-2.92.44-4.4 0-1.48-.15-2.96-.44-4.4z"
    />
    <path fill="#FF0000" d="M9.95 15.14V8.86L15.4 12l-5.45 3.14z" />
  </svg>
);

const NETWORKS = [
  { key: "instagram", label: "Instagram", Glyph: InstagramGlyph, href: SITE.social.instagram },
  { key: "facebook", label: "Facebook", Glyph: FacebookGlyph, href: SITE.social.facebook },
  { key: "linkedin", label: "LinkedIn", Glyph: LinkedInGlyph, href: SITE.social.linkedin },
  { key: "tiktok", label: "TikTok", Glyph: TikTokGlyph, href: SITE.social.tiktok },
  { key: "youtube", label: "YouTube", Glyph: YouTubeGlyph, href: SITE.social.youtube },
];

export default function SocialLinks({ title = "Suivez VirtualPeek®", testIdPrefix = "footer-social" }) {
  return (
    <div data-testid="footer-socials">
      {title && <div className="vp-social-title">{title}</div>}
      <ul className="vp-social-row">
        {NETWORKS.map(({ key, label, Glyph, href }) => (
          <li key={key}>
            <a
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={`${label} — ouvre dans un nouvel onglet`}
              data-testid={`${testIdPrefix}-${label}`}
              data-tooltip={label}
              className={`vp-social vp-social--${key}`}
            >
              <Glyph className="vp-social__glyph" />
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}
